import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { PersonAddAltOutlined } from '@mui/icons-material';
import { useTranslate } from 'react-admin';
import { usePermissions } from 'react-admin';
import { BIG_CLIENT_SITE_MANAGER, BIG_CLIENT_SITE_OPERATOR, ROLE_BIG_CREATE_CLIENT } from '@/utils/CONST';
import ClientsList from '@/components/navigation/navigation-items/clients-list';
import SitesList from '@/components/navigation/navigation-items/sites-list';
import CustomBlock from '@/components/common/custom-block/custom-block';
import { useRef } from 'react';

const NavigationContainer = () => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const isSiteManager = permissions?.includes(BIG_CLIENT_SITE_MANAGER) || permissions?.includes(BIG_CLIENT_SITE_OPERATOR);
    
    const clientsListRef = useRef<{ openCreateDialog: () => void }>(null);

    const handleCreateClient = () => {
        clientsListRef.current?.openCreateDialog();
    };

    return (
        <CustomBlock test={'client-navigation'} label={translate('main.navigation_label')}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateRows: permissions?.includes(ROLE_BIG_CREATE_CLIENT) ? 'auto 1fr' : '1fr',
                    alignContent: 'start',
                    height: '100%',
                    overflowY: 'auto',
                }}
            >
                {!isSiteManager && permissions?.includes(ROLE_BIG_CREATE_CLIENT) && (
                    <Box p={0.5} display={'grid'} gridTemplateColumns={'1fr'}>
                        <Button onClick={handleCreateClient}>
                            <Box display={'flex'} gap={1} alignItems={'center'} fontSize={24}>
                                <PersonAddAltOutlined />

                                <Typography variant={'button'} fontSize={12} fontWeight={700}>
                                    {translate('buttons.add_client')}
                                </Typography>
                            </Box>
                        </Button>
                    </Box>
                )}

                {isSiteManager ? <SitesList /> : <ClientsList ref={clientsListRef} />}
            </Box>
        </CustomBlock>
    );
};

export default NavigationContainer;
